module.exports = __webpack_public_path__ + "static/media/CRM.a67cebac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CRM.svg
// module id = 2068
// module chunks = 0